<template>
  <div class="mobile-header mobile">
    <el-row>
      <el-col :span="2" :offset="22" style="text-align:center">
        <img
          class="logo"
          src="static/img/mobile/login.png"
          @click="$store.commit('dialogVisibleLogin', true)"
        />
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="16" :offset="4" style="text-align:center">
        <router-link :to="{path:'/Mobile/Home'}">
          <img class="logo" src="static/img/logo2022.png" />
        </router-link>
      </el-col>
    </el-row>

    <el-dialog
      title="登录"
      :visible.sync="dialogVisibleLogin"
      width="30%"
      :before-close="handleClose"
      center
    >
      <div class="mobile-login" v-loading="loading">
        <div class="mobile-login-title">因专家数据由中国工程科技研究机构与专家库项目支持，修改数据将需要您的手机号进行认真并赋予您账号对应权限</div>
        <div class="mobile-login-valid mt_10">
          <p class="mt_10">手机验证验证码</p>
          <el-input class="mt_10" placeholder="请输入手机号" v-model="mobile"></el-input>
          <span v-if="valMobile" style="font-size: 10px;color: red;">请输入手机号</span>
          <el-input class="mt_10" placeholder="请输入验证码" v-model="code">
            <el-button
              @click="getCode"
              slot="append"
              :disabled="codeTxt !== '重新获取' && codeTxt !== '获取验证码'"
              style="background-color: #409EFF;color:#fff"
            >{{codeTxt}}</el-button>
          </el-input>
          <span v-if="valCode" style="font-size: 10px;color: red;">请输入验证码</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="$store.commit('dialogVisibleLogin', false)">取 消</el-button>
        <el-button type="primary" @click="login">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { sendCode, valCode } from "@/api/login";
import { isLogin } from "@/api/mobile";
export default {
  name: "mHeader",
  data() {
    return {
      mobile: "",
      code: "",
      valMobile: false,
      valCode: false,
      times: null,
      timer: null,
      codeTxt: "获取验证码",
      loading: false
    };
  },
  computed: {
    dialogVisibleLogin() {
      return this.$store.state.dialogVisibleLogin;
    }
  },

  mounted() {
    isLogin().then(res=>{
      if (res.code === -1) {
        localStorage.removeItem('mobileUser')
      }
    })
  },
  methods: {
    // 获取验证码
    getCode() {
      if (this.valMobile || !this.mobile) {
        this.valMobile = true;
        return;
      }
      let data = {
        mobile: this.mobile
      };
      this.loading = true;
      sendCode(data).then(res => {
        this.loading = false;
        this.$message({
          message: res.msg,
          center: true,
          offset: 200
        });
        if (res.code === 0) {
          console.log(res.code);
          const TIME_COUNT = 61;
          this.times = TIME_COUNT;
          this.timer = setInterval(() => {
            if (this.times > 0 && this.times <= 61) {
              this.codeTxt = this.times;
              this.times--;
            } else {
              this.codeTxt = "重新获取";
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      });
    },
    login() {
      if (this.valMobile || !this.mobile) {
        this.valMobile = true;
        if (!this.code) {
          this.valCode = true;
        }
        return;
      }
      if (this.valCode || !this.code) {
        this.valCode = true;
        return;
      }
      let data = {
        mobile: this.mobile,
        code: this.code
      };
      this.loading = true;
      valCode(data).then(res => {
        this.loading = false;
        this.$message({
          message: res.msg,
          center: true,
          offset: 200
        });
        this.$store.commit("dialogVisibleLogin", false);
        if (!res.code) {
          localStorage.setItem("mobileUser", JSON.stringify(res.data));
        }
      });
    },
    handleClose() {
      this.$store.commit("dialogVisibleLogin", false);
    }
  },
  watch: {
    mobile: {
      handler() {
        if (!this.mobile || !/^1[3456789]\d{9}$/.test(this.mobile)) {
          this.valMobile = true;
        } else {
          this.valMobile = false;
        }
      }
    },
    code: {
      handler() {
        if (this.code) {
          this.valCode = false;
        } else {
          this.valCode = true;
        }
      }
    }
  }
};
</script>

<style scoped>
.mobile-header {
  margin-top: 10px;
  padding: 0 10px;
}
.mobile-header .el-row {
  align-items: center;
  display: flex;
}
.mobile-header img {
  cursor: pointer;
  max-width: 100%;
}
.mobile-login .mobile-login-title {
  padding-bottom: 10px;
  border-bottom: 2px solid #000;
}
.mobile-login-valid {
  margin-top: 10px;
}
.mt_10 {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/mobile/common/Header.vue